import { mutationTypes } from '@/core/constants'

export default {
	methods: {
		criarTokenNoHeaderDasRequisicoes() {
			const token = this.$store.state.parametrosSistema.tokenAcessoSistemaGestaoArquivoEstatico
			const header = { 'token-acesso': token }
			this.$store.commit(mutationTypes.FLOWBEE.SET_HTTP_HEADER, header)
			return header
		},
	},
}
